import React from 'react'   

export default function ListLoader() {
  return (
    <div className='list-loader'>
      <div className='d-flex gap-1'>
        <div className="spinner-grow text-secondary" role="status">
          <span className="sr-only">Loading...</span>
        </div>

        <div className="spinner-grow text-secondary" role="status">
          <span className="sr-only">Loading...</span>
        </div>

        <div className="spinner-grow text-secondary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  )
}